import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components';
import { ButtonProps } from 'components/Button';
import { featureEnabled } from 'utils';
import { Color } from '@bb/elements-web-rebranding';

const AddContactButton: React.FC<ButtonProps> = ({ ...props }) => {
  const ButtonComponent = featureEnabled('supraRebrandingFeature', 1)
    ? StyledButton
    : Button;
  return (
    <ButtonComponent type="primary" {...props} data-cy="contact-add-button">
      Add Contact
    </ButtonComponent>
  );
};

const StyledButton = styled(Button)`
  background-color: ${Color.PRIMARY};
  border-color: ${Color.PRIMARY};
`;

export default AddContactButton;
